import { render, staticRenderFns } from "./HistoryJobs.vue?vue&type=template&id=66ea471a&scoped=true&"
import script from "./HistoryJobs.vue?vue&type=script&lang=js&"
export * from "./HistoryJobs.vue?vue&type=script&lang=js&"
import style0 from "./HistoryJobs.vue?vue&type=style&index=0&id=66ea471a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea471a",
  null
  
)

export default component.exports